import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-4 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#4438CA\" fill-rule=\"evenodd\" d=\"M5.15.006A5.074 5.074 0 0 0 .078 5.08v53.841a5.07 5.07 0 0 0 5.072 5.073h45.775a5.074 5.074 0 0 0 5.074-5.073V20.316L37.096.006z\" clip-rule=\"evenodd\"></path><g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#3830A3\" d=\"M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707z\"></path><path fill=\"#FFF\" d=\"M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799z\" opacity=\".5\"></path></g><path fill=\"#fff\" d=\"m34.238 27.4-2.156 6.51h-9.175l-2.145-6.51H17L25.453 52h4.094L38 27.4zm-3.188 9.633-3.464 10.499h-.183l-3.464-10.499z\"></path>", 3)
  ]))]))
}
export default { render: render }